var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPigogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95683 16.2953H7.94138C7.94138 17.9881 6.56911 19.3604 4.87634 19.3604H3.95683V16.2953Z",
    fill: "#E9688A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.443 7.10022C17.443 10.8243 14.424 13.8433 10.6999 13.8433C9.71711 13.8433 8.78343 13.633 7.94137 13.2551V15.6823H3.95683V7.10022C3.95683 3.37612 6.97581 0.357147 10.6999 0.357147C14.424 0.357147 17.443 3.37612 17.443 7.10022ZM7.02186 7.10022C7.02186 5.24132 8.66608 3.72868 10.6939 3.72868C12.7217 3.72868 14.3779 5.24132 14.3779 7.10022C14.3779 8.95912 12.7217 10.4718 10.6939 10.4718C8.66608 10.4718 7.02186 8.9576 7.02186 7.10022Z",
    fill: "#313D53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigogo);
export default __webpack_public_path__ + "static/media/pigogo.e578dfa1641139bfcd9f588dd8cf902e.svg";
export { ForwardRef as ReactComponent };